/**
 * Parallax Funktionalität hinzufügen
 * Anwendung / Beispiel: parallax('.container');
 *
 * @param containerSelector
 */
function parallax(containerSelector) {
    $(window).on('scroll', function () {
        scrollPos = $(containerSelector).scrollTop();
        $(containerSelector).css({
            'transform': 'translate3d(0px, ' + (scrollPos / 2) + 'px, 0px)'
        });
    });
}